import { render, staticRenderFns } from "./attrDetail.vue?vue&type=template&id=06149b9c&scoped=true&"
import script from "./attrDetail.vue?vue&type=script&lang=js&"
export * from "./attrDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06149b9c",
  null
  
)

export default component.exports